<template>
  <div class="up-region-picker-panel">
    <div class="up-region-picker-panel__inner">
      <div class="up-region-picker__header up-region-picker-panel__header">{{title.parent}}</div>
      <div class="up-region-picker-panel__body">
        <el-checkbox
          class="up-region-picker-panel__all"
          v-model="checkAllProvince"
          @change="(value) => handleCheckAllChange('province', value)"
        >全选</el-checkbox>
        <el-checkbox-group
          class="up-region-picker-panel__parts"
          v-model="selectedProvinces"
          @change="(value) => handleCheckedItemsChange('province', value)"
        >
          <div
            class="up-region-picker-panel__part"
            :class="{ 'is-active': currentProvince && currentProvince.value === item.value }"
            v-for="(item, index) in data"
            :key="item.value"
          >
            <el-checkbox
              :label="item.value"
              @change="(value) => handleItemClick('province', item, index, item.value)"
            >
              <div
                class="up-region-picker-panel__content"
                @click="(e) => handleContentClick('province', item, index, e)"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.label"
                  placement="top-start"
                  :disabled="true"
                >
                  <div>
                    <span>{{item.label}}</span>
                  </div>
                </el-tooltip>
                <i class="el-icon-arrow-right" v-show="item.children && item.children.length > 0"></i>
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="up-region-picker-panel__footer"></div>
    </div>
    <div class="up-region-picker-panel" v-if="currentProvince">
      <div class="up-region-picker-panel__inner">
        <div class="up-region-picker__header up-region-picker-panel__header">{{title.children}}</div>
        <div class="up-region-picker-panel__body">
          <el-checkbox
            class="up-region-picker-panel__all"
            :key="currentProvince.value"
            v-model="checkAllCity"
            @change="(value) => handleCheckAllChange('city', value)"
          >全选</el-checkbox>
          <el-checkbox-group
            class="up-region-picker-panel__parts"
            v-model="selectedCities"
            @change="(value) => handleCheckedItemsChange('city', value)"
          >
            <div
              class="up-region-picker-panel__part"
              v-for="(item, index) in currentProvince.children"
              :key="item.value"
              :class="{ 'is-active': false }"
            >
              <el-checkbox
                :label="item.value"
                @change="(value) => handleItemClick('city', item, index, item.value)"
              >
                <div
                  class="up-region-picker-panel__content"
                  @click="(e) => handleContentClick('city', item, index, e)"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.label"
                    placement="top-start"
                    ref="contentStyle"
                    :disabled="title.parent === '省份'"
                  >
                    <div>
                      <span>{{item.label}}</span>
                    </div>
                  </el-tooltip>
                  <i class="el-icon-arrow-right" v-show="item.children && item.children.length > 0"></i>
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="up-region-picker-panel__footer"></div>
      </div>
    </div>
    <!-- <up-region-picker-panel
      v-if="subData && subData.length"
      :parent="subParent"
      :isParentSelected="isSubParentSelected"
      :data="subData"
      v-model="selectedData"
      @change="handleSubChange"
    ></up-region-picker-panel>-->
  </div>
</template>

<script>
import Checkbox from 'element-ui/packages/checkbox'
import CheckboxGroup from 'element-ui/packages/checkbox-group'
// import UpCheckbox from 'element-up/packages/checkbox'

export default {
  name: 'UpRegionPickerPanel',

  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
    // UpCheckbox
  },

  props: {
    value: {},
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: Object,
      default: () => {
        return {
          parent: '省份',
          children: '城市'
        }
      }
    },
    province: String
  },
  data () {
    return {
      checkAllProvince: false,
      selectedProvinces: [],
      currentProvince: null,
      checkAllCity: false,
      selectedCities: [],
      selectedData: []
    }
  },
  mounted () {
  },
  watch: {
    value: {
      handler (newVal) {
        if (!newVal) return
        this.selectedData = newVal
        this.selectedProvinces = this.getField(newVal.filter(item => item.isAll), 'value')
        this.checkAllProvince = this.data.length > 0 && this.selectedProvinces.length === this.data.length
        if (this.currentProvince) {
          const selectedCurrentProvinceData = this.findByValue('find', this.selectedData, this.currentProvince.value)
          const currentProvinceData = this.findByValue('find', this.data, this.currentProvince.value)
          this.selectedCities = selectedCurrentProvinceData ? this.getField(selectedCurrentProvinceData.children, 'value') : []
          this.checkAllCity = currentProvinceData && this.selectedCities.length === currentProvinceData.children.length
        }
      },
      immediate: true
    },
    province (newVal) {
      if (newVal) {
        const selectedCurrentProvinceData = this.findByValue('find', this.selectedData, newVal)
        const currentProvinceData = this.findByValue('find', this.data, newVal)
        if (currentProvinceData.children && currentProvinceData.children.length) {
          this.currentProvince = currentProvinceData
          this.selectedCities = selectedCurrentProvinceData ? this.getField(selectedCurrentProvinceData.children, 'value') : []
          this.checkAllCity = this.selectedCities.length === currentProvinceData.children.length
        } else {
          this.currentProvince = null
        }
      }
    },
    selectedData (newVal) {
      this.$emit('input', newVal)
      this.$emit('change', newVal)
    },
    data: {
      handler (newVal) {
        this.currentProvince = null
      },
      deep: true
    }
  },

  methods: {
    findByValue (methodName, data, value) {
      return data[methodName](item => item.value === value)
    },
    getField (data, field = 'value') {
      return data.map(item => item[field])
    },
    updateCitiesByProvince (value) {

    },
    toolTip (el, label) {
      // if (el) {
      //   el.$el.children[0].style.display = 'inline-block'
      //   let width = el.$el.children[0].clientWidth
      //   console.log(width)
      //   el.$el.children[0].style.display = 'inline'
      //   return width < 120
      // } else {
      //   return true
      // }
      /* this.$nextTick(() => {
        if (el) {
          let width = el.$el.children[0].clientWidth
          console.log(width, label)
        }
      }) */
    },
    handleCheckAllChange (type, value) {
      // console.log('handleCheckAllChange', type, value)
      if (type === 'province') {
        value = this.checkAllProvince

        this.selectedProvinces = value ? this.getField(this.data, 'value') : []

        if (value) { // 选择了所有省份
          this.selectedData = this.data.map(item => ({
            ...item,
            isAll: true
          }))

          if (this.currentProvince && !this.checkAllCity) {
            this.selectedCities = this.getField(this.currentProvince.children, 'value')
            this.checkAllCity = true
          }
        } else { // 清空所有省份
          this.selectedData.splice(0)
          this.checkAllCity = false
          this.selectedCities.splice(0)
        }
      } else if (type === 'city') {
        value = this.checkAllCity

        if (value) {
          this.selectedCities = this.getField(this.currentProvince.children, 'value')
          this.selectedProvinces.push(this.currentProvince.value)

          const idx = this.findByValue('findIndex', this.selectedData, this.currentProvince.value)
          if (idx > -1) {
            this.selectedData.splice(idx, 1, { ...this.currentProvince, isAll: true })
          } else {
            this.selectedData.push({ ...this.currentProvince, isAll: true })
          }
        } else {
          this.selectedCities.splice(0)
          this.selectedProvinces.splice(this.selectedProvinces.indexOf(this.currentProvince.value), 1)

          const idx = this.findByValue('findIndex', this.selectedData, this.currentProvince.value)
          if (idx > -1) {
            this.selectedData.splice(idx, 1)
          }
        }

        this.checkAllProvince = this.selectedProvinces.length === this.data.length
      }
    },
    handleCheckedItemsChange (type, value) {
      // console.log('handleCheckedItemsChange: ', type, value)
      let checkedCount = value.length
      if (type === 'province') {
        this.checkAllProvince = checkedCount === this.data.length
      } else if (type === 'city') {
        this.checkAllCity = checkedCount === this.currentProvince.children.length
        if (!this.checkAllCity) {
          const provinceIdx = this.selectedProvinces.indexOf(this.currentProvince.value)
          if (provinceIdx > -1) {
            this.selectedProvinces.splice(provinceIdx, 1)
          }

          const dataIdx = this.findByValue('findIndex', this.selectedData, this.currentProvince.value)
          if (dataIdx > -1) {
            if (!value.length) { // 如果选中的省份下没有城市了，则移除省份
              this.selectedData.splice(dataIdx, 1)
            } else { // 过滤出选中的城市
              this.selectedData.splice(dataIdx, 1, {
                ...this.currentProvince,
                children: this.currentProvince.children.filter(child => value.indexOf(child.value) > -1),
                isAll: false
              })
            }
          } else {
            this.selectedData.push({
              ...this.currentProvince,
              children: this.currentProvince.children.filter(child => value.indexOf(child.value) > -1),
              isAll: false
            })
          }
        } else {
          this.selectedProvinces.push(this.currentProvince.value)
          const idx = this.findByValue('findIndex', this.selectedData, this.currentProvince.value)
          if (idx > -1) {
            this.selectedData.splice(idx, 1, { ...this.currentProvince, isAll: true })
          } else {
            this.selectedData.push({ ...this.currentProvince, isAll: true })
          }
        }

        this.checkAllProvince = this.selectedProvinces.length === this.data.length
      }
    },
    handleItemClick (type, item, index, event) {
      // console.log('handleItemClick: ', type, item, index, event.target.value)
      const value = this.selectedProvinces.indexOf(event) > -1
      // const value = event
      if (type === 'province') {
        if (item.children && item.children.length) {
          this.currentProvince = item

          if (value) {
            this.selectedCities = this.getField(item.children, 'value')
            this.checkAllCity = true
          } else {
            this.selectedCities.splice(0)
            this.checkAllCity = false
          }
        }
        if (value) {
          const idx = this.findByValue('findIndex', this.selectedData, item.value)
          if (idx > -1) {
            this.selectedData.splice(idx, 1, { ...item, isAll: true })
          } else {
            this.selectedData.push({ ...item, isAll: true })
          }
        } else {
          this.selectedData.splice(this.findByValue('findIndex', this.selectedData, item.value), 1)
        }
      }
    },
    handleContentClick (type, item, index, event) {
      // console.log('handleContentClick: ', type, item, index, event)
      if (item.children && item.children.length > 0) {
        this.currentProvince = item

        if (this.selectedProvinces.indexOf(item.value) > -1) { // 如果选中了
          this.selectedCities = this.getField(item.children, 'value')
          this.checkAllCity = true
        } else {
          const province = this.findByValue('find', this.selectedData, item.value)
          this.selectedCities = province ? this.getField(province.children, 'value') : []
          this.checkAllCity = false
        }

        event.stopPropagation()
        event.preventDefault()
      } else if (type === 'province') {
        this.currentProvince = null
      }
    }
  }
}
</script>

<style lang="scss">
@include b(up-region-picker-panel) {
  display: flex;
  border-radius: 4px;

  > .up-region-picker-panel {
    flex: 1;
    margin-left: -1px;
  }

  @include e(inner) {
    flex: 1;
    width: 100%;
    border: 1px solid #ebeef5;
    box-sizing: border-box;

    & + .up-region-picker-panel {
      margin-left: -1px;
    }
  }

  @include e(body) {
    // padding: 0 24px 0 14px;
  }

  @include e(all) {
    padding: 0 24px 0 14px;
    height: 36px;

    &.el-checkbox {
      display: flex;
      align-items: center;
      margin-right: 0;
      border-bottom: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }

  @include e(parts) {
    height: 224px;
    overflow: auto;
  }

  @include e(part) {
    padding: 0 12px 0 15px;

    @include p(":hover", ".is-active") {
      background-color: #f5f7fa;

      .el-checkbox__label {
        color: #e21d25;
      }
    }

    .el-checkbox {
      display: flex;
      align-items: center;
      height: 36px;
    }

    .el-checkbox__label {
      width: 100%;
      height: 100%;
      line-height: 36px;
    }
  }

  @include e(content) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      // display: inline-block;
    }
    div {
      max-width: 220px;
      min-width: 120px;
      // width: 120px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
